import React from 'react';
import { History } from 'lucide-react';
import { DOSSIER_STATUSES_LABELS } from '../../../../constants/dossierStatuses';

export default function DossierTimeline({ history }) {
 // Sort ascending (chronological: oldest first)
 const sortedHistory = [...history].sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt));

 return (
 <div className="workspace-card p-6">
   <div className="mb-6">
     <h3 className="text-lg font-bold text-primary mb-1 flex items-center gap-2">
       <History className="w-5 h-5 text-primary" />
       Historique des statuts
     </h3>
     <p className="text-sm text-tertiary">Retrouvez toutes les modifications de statuts effectuées sur ce dossier.</p>
   </div>
   
   <div className="overflow-x-auto max-h-[500px] overflow-y-auto">
     <table className="w-full text-left border-collapse">
       <thead>
         <tr className="border-b border-workspace text-sm text-tertiary sticky top-0 bg-surface z-10">
           <th className="py-3 px-4 font-semibold">Date & Heure</th>
           <th className="py-3 px-4 font-semibold">Ancien Statut</th>
           <th className="py-3 px-4 font-semibold">Nouveau Statut</th>
           <th className="py-3 px-4 font-semibold">Modifié par</th>
         </tr>
       </thead>
       <tbody className="divide-y divide-workspace">
         {sortedHistory.map(h => (
           <tr key={h.id} className="hover:bg-surface-muted transition-colors text-sm">
             <td className="py-3 px-4 text-secondary whitespace-nowrap">
               {new Date(h.changedAt).toLocaleString()}
             </td>
             <td className="py-3 px-4 text-tertiary">
               {DOSSIER_STATUSES_LABELS[h.oldStatus] || h.oldStatus || '-'}
             </td>
             <td className="py-3 px-4 font-medium text-primary">
               {DOSSIER_STATUSES_LABELS[h.newStatus] || h.newStatus}
             </td>
             <td className="py-3 px-4 text-secondary">
               {h.changedBy?.Nom || 'Système'}
             </td>
           </tr>
         ))}
         {sortedHistory.length === 0 && (
           <tr>
             <td colSpan="4" className="py-8 text-center text-tertiary text-sm italic">
               Aucun historique disponible
             </td>
           </tr>
         )}
       </tbody>
     </table>
   </div>
 </div>
 );
}
